// extracted by mini-css-extract-plugin
export default {"region-footer":"Footer_region-footer__xdo7f","block-footer-block":"Footer_block-footer-block__kXhFQ","bmbf":"Footer_bmbf__-WaHP","num":"Footer_num__CuONB"};